export const PaymentsTermsIcon = () => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.75 4.44336H5.25C4.85218 4.44336 4.47064 4.60139 4.18934 4.8827C3.90804 5.164 3.75 5.54553 3.75 5.94336V14.9434C3.75 15.3412 3.90804 15.7227 4.18934 16.004C4.47064 16.2853 4.85218 16.4434 5.25 16.4434H12.75C13.1478 16.4434 13.5294 16.2853 13.8107 16.004C14.092 15.7227 14.25 15.3412 14.25 14.9434V5.94336C14.25 5.54553 14.092 5.164 13.8107 4.8827C13.5294 4.60139 13.1478 4.44336 12.75 4.44336H11.25"
        stroke="#05796B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 4.44336C6.75 4.04553 6.90804 3.664 7.18934 3.3827C7.47064 3.10139 7.85218 2.94336 8.25 2.94336H9.75C10.1478 2.94336 10.5294 3.10139 10.8107 3.3827C11.092 3.664 11.25 4.04553 11.25 4.44336C11.25 4.84118 11.092 5.22272 10.8107 5.50402C10.5294 5.78532 10.1478 5.94336 9.75 5.94336H8.25C7.85218 5.94336 7.47064 5.78532 7.18934 5.50402C6.90804 5.22272 6.75 4.84118 6.75 4.44336Z"
        stroke="#05796B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 8.94336H8.625C8.32663 8.94336 8.04048 9.06189 7.8295 9.27286C7.61853 9.48384 7.5 9.76999 7.5 10.0684C7.5 10.3667 7.61853 10.6529 7.8295 10.8639C8.04048 11.0748 8.32663 11.1934 8.625 11.1934H9.375C9.67337 11.1934 9.95952 11.3119 10.1705 11.5229C10.3815 11.7338 10.5 12.02 10.5 12.3184C10.5 12.6167 10.3815 12.9029 10.1705 13.1139C9.95952 13.3248 9.67337 13.4434 9.375 13.4434H7.5"
        stroke="#05796B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 13.4434V14.1934M9 8.19336V8.94336" stroke="#05796B" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
